<modal-layout-right modalTitle="Size Guide">

    <!-- content -->
    <div modalBody>
        <icms-outlet [components]=" content?.components "></icms-outlet>
    </div>

</modal-layout-right>
